export const DONT_SHOW = '{{dontShow}}';
